import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";
import api from "../../lib/api";
import { AdminHeader, Btn, DataTable, Card, Input } from "../../components/admin/Fields";

const empty = () => ({ from_path: "", to_path: "", status_code: 301, active: true, note: "" });

const AdminRedirectsPage = () => {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(empty());
  const [busy, setBusy] = useState(false);
  const [creating, setCreating] = useState(false);

  const load = () => api.get("/admin/redirects").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/admin/redirects", { ...form, status_code: Number(form.status_code) || 301 });
      toast.success("Eklendi"); setForm(empty()); setCreating(false); load();
    } catch (err) { toast.error(err?.response?.data?.detail || err.message); } finally { setBusy(false); }
  };
  const toggle = async (r) => { await api.put(`/admin/redirects/${r.id}`, { active: !r.active }); load(); };
  const remove = async (r) => { if (!window.confirm(`"${r.from_path}" silinsin mi?`)) return; await api.delete(`/admin/redirects/${r.id}`); load(); };

  return (
    <div data-testid="admin-redirects-page">
      <AdminHeader eyebrow="SEO" title="Yönlendirmeler (Redirects)" action={<Btn onClick={() => setCreating(true)} testId="new-redirect"><Plus size={14} /> Yeni</Btn>} />
      {creating ? (
        <Card title="Yeni Yönlendirme">
          <form onSubmit={create} className="grid grid-cols-1 md:grid-cols-6 gap-4 items-end">
            <Input label="Kaynak Yol (/eski)" value={form.from_path} onChange={(v) => setForm({ ...form, from_path: v })} testId="redirect-from" />
            <Input label="Hedef (/yeni ya da URL)" value={form.to_path} onChange={(v) => setForm({ ...form, to_path: v })} testId="redirect-to" />
            <Input label="Kod" type="number" value={form.status_code} onChange={(v) => setForm({ ...form, status_code: v })} />
            <Input label="Not (opsiyonel)" value={form.note} onChange={(v) => setForm({ ...form, note: v })} className="md:col-span-2" />
            <div className="flex gap-3">
              <Btn type="submit" disabled={busy} testId="redirect-save">Kaydet</Btn>
              <Btn variant="ghost" onClick={() => setCreating(false)}>İptal</Btn>
            </div>
          </form>
        </Card>
      ) : null}
      <div className="mt-6">
        <DataTable
          columns={[
            { key: "from_path", label: "Kaynak" },
            { key: "to_path", label: "Hedef" },
            { key: "status_code", label: "Kod" },
            { key: "active", label: "Aktif", render: (r) => <button type="button" onClick={() => toggle(r)} className={`px-2 py-1 text-xs uppercase tracking-[0.18em] border ${r.active ? "border-brand-navy text-brand-navy" : "border-black/15 text-brand-medium"}`}>{r.active ? "Aktif" : "Pasif"}</button> },
            { key: "note", label: "Not" },
            { key: "actions", label: "", render: (r) => <div className="flex justify-end"><Btn variant="danger" onClick={() => remove(r)}><Trash2 size={12} /></Btn></div> },
          ]}
          rows={rows}
        />
      </div>
    </div>
  );
};

export default AdminRedirectsPage;
